import type { UnknownAction } from 'redux';
import type { ThunkDispatch } from 'redux-thunk';
import { useDispatch } from 'react-redux';
import type { ApiErrorAction } from '../Actions/apiActions';

// UnknownAction covers the loosely-typed common/loading actions; ApiErrorAction is the one concrete
// action type dispatched from TS (a named interface isn't assignable to UnknownAction on its own,
// since UnknownAction's index signature is `unknown`). State stays unknown until the store is typed.
export type AppDispatch = ThunkDispatch<unknown, undefined, ApiErrorAction | UnknownAction>;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
